import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ContentSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section id="content" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-px flex-1 bg-background-300/60"></div>
          <span className="text-xs font-semibold uppercase tracking-widest text-foreground-400 whitespace-nowrap">
            Kakobuy Spreadsheet
          </span>
          <div className="h-px flex-1 bg-background-300/60"></div>
        </div>

        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4 text-center">
          {t('content.title')}
        </h2>
        <p className="text-sm text-foreground-600 text-center max-w-2xl mx-auto mb-10 md:mb-12">
          Odkryj nasze szczegółowe poradniki i przewodniki — wszystko, co musisz wiedzieć o Kakobuy Spreadsheet, bezpiecznych zakupach i najlepszych okazjach z chińskich platform.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-10">
          {articles.map((article) => (
            <button
              key={article.slug}
              onClick={() => {
                navigate(`/artykul/${article.slug}`);
                window.scrollTo(0, 0);
              }}
              className="group text-left bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300 hover:shadow-sm transition-all duration-200 cursor-pointer w-full"
            >
              <div className="w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.h1}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  title={article.h1}
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 text-xs rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs text-primary-600 font-medium">
                  <span>Czytaj więcej</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer no-underline"
          >
            Kakobuy Spreadsheet
          </a>
        </div>
      </div>
    </section>
  );
}